import { render, staticRenderFns } from "./CardTable.vue?vue&type=template&id=41f3b400&scoped=true&"
import script from "./CardTable.vue?vue&type=script&lang=ts&"
export * from "./CardTable.vue?vue&type=script&lang=ts&"
import style0 from "./CardTable.vue?vue&type=style&index=0&id=41f3b400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f3b400",
  null
  
)

component.options.__file = "CardTable.vue"
export default component.exports